import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
var SET_BASE_URL = 'SET_BASE_URL';
export default SET_BASE_URL;